import { useSortable } from '@dnd-kit/sortable';
import { ID } from 'shared/types/id';

// Activator on the handle, never the row: on the row it arms the pointer sensor over the row's own text, which dnd-kit then wipes.
export const useSortableDragHandle = (id: ID) => {
  const {
    setNodeRef,
    setActivatorNodeRef,
    attributes,
    listeners,
    isDragging,
    transform,
    transition,
  } = useSortable({ id: id });

  return {
    containerProps: {
      ref: setNodeRef,
      $transform: transform,
      $transition: transition,
    },
    handleProps: {
      ref: setActivatorNodeRef,
      ...attributes,
      ...listeners,
    },
    isDragging,
  };
};
